import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { PaymentDetailComponent } from './payment-detail.component';
import { PaymentDetailModel } from '@common/interfaces/payment-detail/payment-detail';
import { PaymentDetailS02P020Data } from '@common/interfaces/payment-detail/payment-detail-s02-p020';
import { PaymentDetailS01P031Data } from '@common/interfaces/payment-detail/payment-detail-s02-p031';
import { ServicingFunctionIdType, ServicingPageIdType } from '@common/interfaces';

export function buildPaymentDetailModalBlockParts(): ModalBlockParts {
  return {
    id: 'PaymentDetailModal',
    block: PaymentDetailComponent,
    closeBackEnable: true,
    type: ModalType.TYPE2,
    modalWidth: LModalContentsWidthType.MODAL_PC_W1000,
    payload: {
      subFunctionId: ServicingFunctionIdType.BOOKING_CONFIRMATION,
      subPageId: ServicingPageIdType.MYBOOKING_ITINERARY,
      data: {} as PaymentDetailS02P020Data | PaymentDetailS01P031Data,
    },
  };
}

export function buildPaymentModalPayload(
  subFunctionId: string,
  subPageId: string,
  data: PaymentDetailS02P020Data | PaymentDetailS01P031Data
) {
  return {
    subFunctionId: subFunctionId,
    subPageId: subPageId,
    data: data,
  } as PaymentDetailModel;
}
